<template>
  <div>
    <ul class="search-btn">
      <li v-if="isShowSelectGroup">
        <span class="m-r-6">销售群组</span>
        <SpSearchGroup @changeGroup="changeGroup" />
      </li>
      <li>
        <span class="m-r-6">店铺编号</span>
        <el-input
          v-model="params.store_bn"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <span class="m-r-6">店铺名称</span>
        <el-input
          v-model="params.store_name"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <el-button
          type="primary"
          @click="searchList"
        >
          查询
        </el-button>
        <el-button
          type="text"
          @click="refreshStore"
        >
          同步店铺
        </el-button>
      </li>
    </ul>

    <div style="margin-bottom: 15px" />
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="storeData"
      tooltip-effect="dark"
      :row-key="getRowKeys"
      @select="handleSelectionChange"
      @select-all="selectAll"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="50"
      />
      <el-table-column
        prop="store_bn"
        width="200px"
        label="店铺编号"
      />
      <el-table-column
        prop="store_name"
        label="店铺名称"
      />
    </el-table>

    <div class="select-footer">
      <div>
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :total="total_count"
          :current-page="params.page"
          :page-size="params.page_size"
          @current-change="handleCurrentChange"
        />
      </div>
      <div>
        <span class="m-r-6">已选中{{ selectCount }}个店铺</span>
        <el-button
          type="primary"
          @click="saveStoreAction"
        >
          确定
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getStoreList } from '@/api/component'
export default {
  name: 'SpStoreSelect',
  props: {
    selectedStoreIds: {
      // 已勾选的门店列表
      type: Array
    },
    showStore: {
      type: Boolean,
      default: true
    },
    chooseOnlyStore: {
      type: Boolean,
      default: false
    },
    isShowSelectGroup: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      storeData: [],
      total_count: 0,
      params: {
        page: 1,
        page_size: 10,
        region: '',
        store_name: '',
        store_bn: ''
      },
      selectCount: 0
    }
  },
  watch: {},
  mounted () {
    if (this.showStore) {
      this.getNewsList('getFirst')
    }
    console.log('selectedStoreIds', this.selectedStoreIds)
  },
  methods: {
    // 换页可选择
    getRowKeys (row) {
      return row.store_id
    },

    // 分页器页面切换
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getNewsList()
    },

    // 查询门店
    searchList () {
      this.params.page = 1
      this.getNewsList()
    },

    // 全选事件
    selectAll (val) {},
    // table表格选择
    handleSelectionChange (selection, row) {
      if (this.chooseOnlyStore) {
        this.$refs.multipleTable.clearSelection()
        if (selection.length === 0) {
          // 判断selection是否有值存在
          return
        }
        if (row) {
          this.selectioned = row
          this.$refs.multipleTable.toggleRowSelection(row, true)
        }
      }
      this.selectCount = this.$refs.multipleTable.selection.length
    },
    // 关闭模态框
    cancelAction () {
      this.$emit('showDialogChange', false)

      // 如果不需要默认勾选则关闭取消
      if (!this.selectedStoreIds) {
        this.selectCount = 0
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 保存绑定
    saveStoreAction () {
      // 保存storeIds
      let storeIds = []
      this.$refs.multipleTable.selection.forEach((v) => {
        storeIds = storeIds.concat(v.store_id)
      })
      this.$emit('chooseStore', storeIds)
    },
    // 获取门店列表
    async getNewsList (type) {
      this.loading = true
      const data = await getStoreList(this.params)
      if (data) {
        if (data.total_count < 1 && type === 'getFirst') {
          this.refreshStore('first')
        }
        this.loading = false
        this.storeData = data.list
        this.total_count = data.total_count

        // 获取选中元素 可传数组对象，也可传数组id
        if (type) {
          this.toggleSelection(this.selectedStoreIds)
        }
      }
    },
    toggleSelection (rows) {
      if (rows && rows.length > 0) {
        rows.forEach((row) => {
          if (row.store_id) {
            // row = {contract_phone: "",region_id: "",store_bn: "",store_id: 615,store_name: ""}
            this.$refs.multipleTable.toggleRowSelection(row, true)
          } else {
            // row = 615
            let newrow = { store_id: row }
            this.$refs.multipleTable.toggleRowSelection(newrow, true)
          }
          this.selectCount = this.$refs.multipleTable.selection.length
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },

    // 同步更新门店
    async refreshStore (type) {
      const data = await this.$api.component.refreshStore()
      if (data && type !== 'first') {
        this.$message({
          message: '更新同步成功',
          type: 'success'
        })
      }
    },

    // 群组查询
    changeGroup (val) {
      if (val && val.length > 0) {
        this.params.group_code = val[val.length - 1]
      } else {
        this.params.group_code = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}

.select-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

::v-deep {
  .el-table__header {
    .el-table-column--selection {
      .cell {
        .el-checkbox {
          display: none;
        }
      }
    }
  }
}
</style>
